<!-- 关联货源&编辑货源 -->
<template>
    <div>
        <div class="data-row" style="margin: 0px 15px 15px 15px;">
            <table :style="{ width: '80%', minWidth: '600px'}">
                <tr style="background-color: #fff;">
                    <td style="width: 80%; min-width: 260px;">
                        <div class="item1">
                            <span style="width: 100px; min-width: 100px; height: 100px; overflow: hidden; position: relative;">
                                <el-image  style="width: 100px; min-width: 100px; height: 100px" 
                                    :src="kit.api.imgView+goodsDetail.productThumb" 
                                    :preview-src-list="[kit.api.imgView+goodsDetail.productThumb]"
                                ></el-image>
                            </span>
                            <div class="product-info">
                                <div class="cell-1 product-row">
                                    <span class="product-title">{{ goodsDetail.productTitle }}</span>
                                </div>
                                <div class="cell-1">
                                    <span>商品ID：</span>
                                    <span>{{ goodsDetail.productId }}</span>
                                </div>
                                <div class="cell-1">
                                    <span>规&nbsp;&nbsp;&nbsp;&nbsp;格：</span>
                                    <span>{{ goodsDetail.productSpec }}</span>
                                </div>
                                <div class="cell-1">
                                    <span>S&nbsp;&nbsp;K&nbsp;&nbsp;U：</span>
                                    <span>{{ goodsDetail.sku }}</span>
                                </div>
                                <div class="cell-1">
                                    <span>货&nbsp;&nbsp;&nbsp;&nbsp;号：</span>
                                    <span>{{ goodsDetail.variationSku }}</span>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </div><!--end data-row-->

        <div style="margin: 10px 10px; display: flex; align-items: center;">
            <span style="width: 70px; margin-right: 10px; font-weight: bold; font-size: 15px; text-align: right; display: inline-block;">添加货源</span>
            <el-input v-model.trim="goodsLink" placeholder="请输入1688、拼多多、淘宝商品详情地址" style="width: 70%; margin-right: 10px;"></el-input>
            <el-button type="danger" size="mini"  @click="addGoodsLink()">
                <i class="el-icon-plus"></i><span>{{msg('添加货源')}}</span>
            </el-button>
        </div>
        <div style="margin: 10px 10px; display: flex; align-items: center;">
            <span style="width: 70px; margin-right: 10px; display: inline-block;"></span>
            <el-checkbox size="medium" v-model="useSameLink">
                <span>
                    同一商品ID不同规格统一使用同一采购链接<span style="color:red;">（只在选中一个商品详情时生效）</span>
                </span>
            </el-checkbox>
        </div>
        <el-table :data="linkDatas" style="width: 100%" border>
            <el-table-column type="index" label="序号" width="100"></el-table-column>
            <el-table-column prop="name" label="货源信息"></el-table-column>
            <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                    <el-button @click="copyLink(scope.row)" type="text" size="small">复制链接</el-button>
                    <!-- <el-button @click="editLink(scope.row)" type="text" size="small">编辑</el-button>  -->
                    <el-button @click="deleteLink(scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div style="text-align:center; margin-top: 15px;">
            <!-- <el-button type="primary" size="mini"  @click="onSubmit"><i class="el-icon-check"></i><span>{{msg('确认')}}</span></el-button> -->
            <el-button  size="mini" v-on:click="$emit('close-dg')">{{msg('关闭')}}</el-button>
        </div>
    </div>
</template> 

<script>
import { Message,MessageBox  } from "element-ui";
import i18nKit from "../../plugins/I18N.js"
let i18n = i18nKit.methods;
export default {
    name: "orderGoodsLink",
    components:{
    },
    data(){
        return {
            options:null,
            templates: [],
            templateDgVisiable: false,
            previewDgVisiable: false,
            templateDgTitle: null,
            editPrintSetting: {
                id: null,
                printTemplateId: null,
                type: null,
                refId: null
            },
            previewHtml:"",
            goodsLink:null,
            linkDatas: [],
            useSameLink:false,
        }
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
            return this.$store.state.isMinScreen;
            }
        },
    },
    mounted(){
    },
    props:{
        goodsDetail:Object,
    },
    methods:{
        init(type){
            this.linkDatas = [];
            this.goodsLink = null;
            this.useSameLink = false;
            if(type == 1){
                this.getPurchaseLink();
            }
        },
        //添加货源
        addGoodsLink(){
            if(!this.goodsLink){
                this.$message('请输入正确的商品链接地址！');
                return;
            }
            let _this = this;
            this.$axios.post(this.$kit.api.stockDetail.openBuyLink+"?id="+this.goodsDetail.stockId+"&detailId="+this.goodsDetail.id+"&purchaseLink="+encodeURIComponent(this.goodsLink)+"&useSameLink="+this.useSameLink)
               .then((result) => {
                    _this.$message(result.msg);
                    if(result.status){
                        _this.getPurchaseLink();
                    }
               })
        },
        //复制链接
        copyLink(row){
            let name = row.name;
            // 创建一个临时的文本区域
            const tempInput = document.createElement('textarea');
            // 设置要复制的文本内容
            tempInput.value = name;
            tempInput.style="opacity:0;"
            // 追加到 body 中
            document.body.appendChild(tempInput);
            // 选中文本
            tempInput.select();
            // 执行复制操作
            document.execCommand('copy');
            // 移除临时文本区域
            document.body.removeChild(tempInput);
            this.$message("成功");
        }, 
        editLink(row){
            var _this = this;
            this.$prompt('请输入采购链接', i18n.msg('提示'), {
                confirmButtonText: i18n.msg('确定'),
                cancelButtonText: i18n.msg('取消'),
            }).then(({ value }) => {
                if(!value){
                    _this.$message(i18n.msg('请输入采购链接'));
                    return;
                }
                if(value && value.length > 100){
                    this.$message(i18n.msg('备注超长，请控制在100字内'));
                    return;
                }
                
                this.$axios.post(this.$kit.api.purchase.update,{id:row.id, taobaoLink:value})
                    .then((result) => {
                            _this.$message(result.msg);
                            if(result.status){
                                _this.getPurchaseLink();
                            }
                    })
            }).catch(() => {
                Message({
                    type: 'info',
                    message: '取消输入'
                });
            });
        },
        //删除
        deleteLink(row){
            var _this = this;
            this.$confirm(i18n.msg('确定要删除货源吗?'), this.msg('提示'), {
                confirmButtonText: this.msg('确定'),
                cancelButtonText: this.msg('取消'),
                type: 'warning'
            }).then(() => {
                _this.$axios.post(_this.$kit.api.purchase.delete+"?ids="+row.id)
                .then((result) => {
                    if(result.status){
                        _this.$message('成功删除'+result.data+'条记录');
                        // _this.list();
                        _this.getPurchaseLink();
                    }else{
                        _this.$message(_this.msg('只能删除自己创建的链接！'));
                    }
                });
            }).catch((err) => {
                // console.log(err);
                Message({
                    type: 'info',
                    message: '取消'
                });
            });
        },
        //获取采购链接
        getPurchaseLink(){
            let _this = this;
            this.$axios.post(this.$kit.api.stockDetail.getPurchaseLink
                            +"?id="+this.goodsDetail.stockId
                            +"&detailId="+this.goodsDetail.id
                            +"&link="+this.goodsDetail.productId
                            +"&spec="+this.goodsDetail.productSpec)
              .then((result) => {
                    // _this.$message(result.msg);
                    if(result.status){
                        let data = result.data;
                        if(data){
                            _this.linkDatas = [];
                            data.forEach(e => {
                                let link = {
                                    id: e.id,
                                    name: e.taobaoLink,
                                };
                                _this.linkDatas.push(link);
                            });
                        }else{
                            _this.linkDatas = [];
                        }
                    }
              })
        },
    }

}
</script>

<style lang="scss" scoped>
.item1 {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    min-width: 0;
    overflow: hidden;
}
.product-info{
    flex: 1;
    min-width: 0;
    overflow: hidden;
    max-width: 100%;
}
</style>